import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-import-tip',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './import-tip.component.html',
  styleUrls: ['./import-tip.component.scss'],
})
export class ImportTipComponent {
  @Output() dismiss = new EventEmitter<void>();
}
